module.exports = __webpack_public_path__ + "static/media/strawberry-dessert-2191973_1280.61dd5b80.jpg";